// Generated by CoffeeScript 1.10.0
(function() {
  var Table;

  Table = (function() {
    function Table(file) {
      var info;
      this.file = file;
      info = this.file.directory.tables[this.tag];
      this.exists = !!info;
      if (info) {
        this.offset = info.offset, this.length = info.length;
        this.parse(this.file.contents);
      }
    }

    Table.prototype.parse = function() {};

    Table.prototype.encode = function() {};

    Table.prototype.raw = function() {
      if (!this.exists) {
        return null;
      }
      this.file.contents.pos = this.offset;
      return this.file.contents.read(this.length);
    };

    return Table;

  })();

  module.exports = Table;

}).call(this);



//////////////////
// WEBPACK FOOTER
// ../~/pdfkit/js/font/table.js
// module id = 47
// module chunks = 0